import React from "react";
import PropTypes from "prop-types";
import { FieldSelect } from "@conserveit/blocks";

const SiteSelect = ({ name, label, onChange, options = [] }) => {
  if (options.length < 1) return null;

  const selectOptions = options.map((site) => ({
    label: site.name,
    value: site.name,
    id: site.id,
  }));

  return (
    <FieldSelect
      id={name}
      name={name}
      label={label}
      placeholder="Select Site..."
      options={selectOptions}
      onChange={({ value }) => onChange(value, name)}
      menuPosition="fixed"
    />
  );
};

SiteSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    })
  ),
};

SiteSelect.defaultProps = {
  value: "",
  options: [],
};

export default SiteSelect;
